//
// Get media types (source : laravel config/mediatypes.php
const configMediaTypes = window.config.mediaTypes

export default Object.freeze(configMediaTypes)
